/*
 * StudentClassInfo Messages
 *
 * This contains all the text for the StudentClassInfo component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
    unassignedEmptyState: {
        id: 'app.components.AssignUser.unassignedEmptyState',
        defaultMessage: 'No classes found'
    },
    assignedEmptyState: {
        id: 'app.components.AssignUser.assignedEmptyState',
        defaultMessage: 'No classes assigned'
    },
    assignedClasses: {
        id: 'app.components.AssignUser.assignedClasses',
        defaultMessage: 'Assigned classes for'
    },
    assignedTeachers: {
        id: 'app.components.AssignUser.assignedTeachers',
        defaultMessage: 'Assigned teachers for'
    },
    available: {
        id: 'app.components.AssignUser.available',
        defaultMessage: 'Available'
    },
    assignedTo: {
        id: 'app.components.AssignUser.assignedTo',
        defaultMessage: 'assigned to'
    },
    teacherEmptyState: {
        id: 'app.components.AssignUser.teacherEmptyState',
        defaultMessage: 'No teachers found'
    },
    cancel: {
        id: 'app.components.AssignUser.cancel',
        defaultMessage: 'Cancel'
    },
    save: {
        id: 'app.components.AssignUser.save',
        defaultMessage: 'Save'
    },
    teachers: {
        id: 'app.components.AssignUser.teachers',
        defaultMessage: 'Teachers'
    },
    classes: {
        id: 'app.components.AssignUser.classes',
        defaultMessage: 'Classes'
    }

});



// WEBPACK FOOTER //
// ./app/components/assign-user/messages.js